// extracted by mini-css-extract-plugin
export default {"background":"DashboardStudent_background__MznNi","row":"DashboardStudent_row__28g7O","col":"DashboardStudent_col__wLjs+","card":"DashboardStudent_card__wyxi7"};